"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepCopy = deepCopy;
/**
 * Głębokie kopiowanie
 * @param data date do skopiowania
 */
function deepCopy(data) {
    return JSON.parse(JSON.stringify(data));
}
//# sourceMappingURL=deepCopy.js.map